module.exports = __webpack_public_path__ + "img/xls.9ac6d6d7.png";